<template>
	<div class="white-box">
		<div class="form-horizontal new-lg-form" @keyup.enter="validate()">
			<a href="javascript:void(0)" class="text-center db">
				<img :src="$env.ROOT + '/img/logo.png'">
			</a>
			<br/>
			<h3 class="box-title m-b-0">{{ $t("generals.reset_password") }}</h3>
			<div class="form-group  m-t-20">
				<div class="col-xs-12">
					<div :class="{ 'has-error' : errors.has('Email Address') }">
						<label class="control-label">Email Address</label>
						<input
							v-model="data.email"
							v-validate="'required|email'"
							class="form-control"
							autofocus
							type="email"
							name="Email Address"
							autocomplete="off"
							placeholder="Email Address">
						<small v-show="errors.has('Email Address')" class="form-text text-danger">
							{{ errors.first('Email Address') }}
						</small>
					</div>
				</div>
			</div>
			<div class="form-group  m-t-20">
				<div class="col-xs-12">
					<div :class="{ 'has-error' : errors.has('Password') }">
						<label class="control-label">Password</label>
						<input
							v-model="data.password"
							v-validate="'required|min:6'"
							class="form-control"
							autofocus
							type="password"
							name="Password"
							autocomplete="off"
							placeholder="Password">
						<small v-show="errors.has('Password')" class="form-text text-danger">
							{{ errors.first('Password') }}
						</small>
					</div>
				</div>
			</div>
			<div class="form-group  m-t-20">
				<div class="col-xs-12">
					<div :class="{ 'has-error' : errors.has('Password confirmation') }">
						<label class="control-label">Password confirmation</label>
						<input
							v-model="data.password_confirmation"
							v-validate="'required|confirmed:Password|min:6'"
							class="form-control"
							autofocus
							type="password"
							name="Password confirmation"
							autocomplete="off"
							placeholder="Password confirmation">
						<small v-show="errors.has('Password confirmation')" class="form-text text-danger">
							{{ errors.first('Password confirmation') }}
						</small>
					</div>
				</div>
			</div>
			<div class="form-group">
				<div class="col-md-12">
					<router-link :to="'/' + $i18n.locale + '/authentication/login'">
						{{ $t("generals.login") }}
					</router-link>
				</div>
			</div>
			<div class="form-group text-center m-t-20">
				<div class="col-xs-12">
					<button
						@click="validate"
						ref="btnReset"
						class="btn btn-primary btn-lg btn-block text-uppercase waves-effect waves-light"
						type="submit">
						{{ $t("generals.reset_password") }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Ladda from 'ladda'
	import swal from 'sweetalert2'

	export default {
		data () {
			return {
				data: {
					email: null,
					password: null,
					password_confirmation: null,
					token: null,
				},
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				if(this.$route.params.token) {
					this.data.token = this.$route.params.token
				}
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.reset()
					}
					return result
				})
			},
			reset () {
				var loading = Ladda.create(this.$refs.btnReset)
				loading.start()
				this.$http.post('password/reset', this.data)
				.then(response => {
					loading.stop()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
					this.$router.push('/' + this.$i18n.locale + '/' + this.$platform.slug + '/authentication/login')
				}).catch(function(response) {
					console.log(response)
					loading.stop()

					if(response.body.title) {
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					} else {
						swal({
							title: response.statusText,
							text: response.body.message,
							type: "warning",
						})
					}
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/authentication/views/Reset.vue